import * as constants from '../constants';

const INITIAL_STATE = {
  fetching: false,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case constants.GET_BOOKINGS_SUCCESS:
      return Object.assign({}, state, {
        bookingResponse: action.bookingResponse,
        refreshBookings: false,
        fetching: false,
      });
    case constants.GET_BOOKING_NOTIFICATION_DATA_SUCCESS:
      return Object.assign({}, state, {
        notificationDataResponse: action.notificationDataResponse,
        refreshBookings: false,
        fetching: false,
      });
    case constants.POST_PREVIEW_CONFIRMATION_SUCCESS:
      return Object.assign({}, state, {
        html: action.html,
      });
    // FIXME: There must be some better way to get around it. Fix it if there is. Following comment might help
    // POST_SEND_CONFIRMATION_SUCCESS: Flags that actuual email has been sent from the Notification api.
    // POST_BOOKING_NOTIFICATION_SUCCESS: Flags the confirmation(email)\code(sms) has been registered in the Booking object at the backend (experience api).
    // isBookingNotifyConfirmationSent is a dedicated flag for confirmation as having same flag will overwrite the other sent date
    case constants.POST_SEND_CONFIRMATION_SUCCESS:
      return Object.assign({}, state, {
        isConfirmationSent: action.isConfirmationSent,
        isBookingNotifyConfirmationSent: false,
      });
    // FIXME: There must be some better way to get around it. Fix it if there is. Following comment might help
    // POST_SEND_CONFIRMATION_SUCCESS: Flags that actuual email has been sent from the Notification api.
    // POST_BOOKING_NOTIFICATION_SUCCESS: Flags the confirmation(email)\code(sms) has been registered in the Booking object at the backend (experience api).
    // isBookingNotifyCodeSent is a dedicated flag for confirmation as having same flag will overwrite the other sent date
    case constants.POST_SEND_CODE_SUCCESS:
      return Object.assign({}, state, {
        isCodeSent: action.isCodeSent,
        isBookingNotifyCodeSent: false,
      });
    case constants.POST_BOOKING_NOTIFICATION_SUCCESS:
      return Object.assign({}, state, {
        isBookingNotifyConfirmationSent: true,
        isBookingNotifyCodeSent: true,
        refreshBookings: true,
      });
    case constants.PATCH_BOOKING_SUCCESS:
    case constants.PUT_BOOKING_ITEM_PRICE_SUCCESS:
    case constants.POST_BOOKING_ITEM_PAYMENT_SUCCESS:
    case constants.POST_BOOKING_ITEM_ACTIVITY_SUCCESS:
    case constants.PUT_BOOKING_MANAGER_SUCCESS:
    case constants.PUT_STOP_BOOKING_NOTES_SUCCESS:
    case constants.DELETE_ONE_BOOKING_ROUTE_SUCCESS:
    case constants.DELETE_ONE_BOOKING_VIRTUAL_SUCCESS:
    case constants.PUT_BOOKING_STOP_SUCCESS:
    case constants.PUT_BOOKING_DELIVERY_STATUS_SUCCESS:  
    case constants.DELETE_ONE_BOOKING_STOP_PROVIDER_SUCCESS:
    case constants.DELETE_ONE_BOOKING_STOP_SPARK_SUCCESS:
    case constants.PATCH_BOOKING_STOPS_ORDER_SUCCESS:
    case constants.PATCH_BOOKINGS_SUCCESS:
    case constants.PUT_BOOKING_IS_PERSONALISED_SUCCESS: 
      return Object.assign({}, state, {
        refreshBookings: true,
      });
    case constants.PATCH_BOOKINGS_REFRESH:
      return Object.assign({}, state, {
        refreshBookings: false,
      });
    case constants.GET_BOOKINGS_ERROR:
    case constants.GET_BOOKING_NOTIFICATION_DATA_ERROR:
    case constants.POST_PREVIEW_CONFIRMATION_ERROR:
    case constants.POST_SEND_CONFIRMATION_ERROR:
    case constants.POST_SEND_CODE_ERROR:
    case constants.PATCH_BOOKING_ERROR:
    case constants.PUT_BOOKING_ITEM_PRICE_ERROR:
    case constants.POST_BOOKING_ITEM_PAYMENT_ERROR:
    case constants.POST_BOOKING_ITEM_ACTIVITY_ERROR:
    case constants.PUT_BOOKING_MANAGER_ERROR:
    case constants.PUT_STOP_BOOKING_NOTES_ERROR:
    case constants.DELETE_ONE_BOOKING_ROUTE_ERROR:
    case constants.DELETE_ONE_BOOKING_VIRTUAL_ERROR:
    case constants.PUT_BOOKING_STOP_ERROR:
    case constants.PUT_BOOKING_DELIVERY_STATUS_ERROR:  
    case constants.DELETE_ONE_BOOKING_STOP_PROVIDER_ERROR:
    case constants.DELETE_ONE_BOOKING_STOP_SPARK_ERROR:
    case constants.PATCH_BOOKINGS_ERROR:
    case constants.PUT_BOOKING_IS_PERSONALISED_ERROR: 
      return {
        ...state,
        error: action.error,
        fetching: false,
      };
    case constants.CLEAR_ERROR:
        return {
            ...state,
            error: undefined
        }
    case constants.GET_BOOKING_ATTEMPT:
      return { ...state, fetching: true, refreshBookings: false, };
    default:
      return state;
  }
}
